

import * as rpc from "@/constants/rpc";
import {POST_CREATE, POST_UPDATE_CV_ID} from "@/constants/rpc";

export default {
    name: 'CvSelectorList',
    props: {
        cvs: Array,
        selectCvId: {
            type: Number,
            default: 0,
        },
        jdId: {
            type: Number,
            default: 0,
        },
        refereeUserId: {
            type: Number,
            default: 0,
        },
        postId: {
            type: Number,
            default: 0,
        },
    },
    data() {
        return {
            newPostId: this.postId,
            newSelectCvId: this.selectCvId
        }
    },
    methods: {
        onClick(item) {
            this.newSelectCvId = item._id
        },
        onSubmit() {
            if (this.newSelectCvId<=0) {
                this.$message.warning("请先选择一个简历")
                return
            }

            if (this.newPostId <=0 ) {
                this.createPost()
            } else {
                this.updatePostCvId()
            }
        },
        async createPost() {
            const p = {
                refereeUserId: this.refereeUserId,
                cvId: this.newSelectCvId,
                jdId:this.jdId,
            }
            const ret = await this.$axios.rpcMsg(rpc.CONTENT, rpc.POST_CREATE, p)
            if (ret && ret.result) {
                this.newPostId = ret.result._id
                this.$message.success("投递简历成功")
                this.$emit("update:selectCvId",this.newSelectCvId)
                this.$emit("closeDrawer")
            }
        },
        async updatePostCvId() {
            const p = {
                postId: this.newPostId,
                cvId: this.newSelectCvId,
            }
            const ret = await this.$axios.rpcMsg(rpc.CONTENT, rpc.POST_UPDATE_CV_ID, p)
            if (ret && ret.result) {
                this.$message.success("投递简历成功")
                this.$emit("update:selectCvId",this.newSelectCvId)
                this.$emit("closeDrawer")
            }
        }
    }
}
